<template>
    <v-form ref="formReset" lazy-validation v-model="formValid">
        <p class="text-h5">Изменение пароля</p>
        <v-text-field
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            :type="showPassword ? 'text' : 'password'"
            v-model="current_password"
            :rules="[v => !!v || 'Поле обязательно для заполнения',]"
            class="mb-4"
            outlined
            dense
            value=""
            placeholder="Текущий пароль"
            persistent-hint
            single-line hint="Введите текущий пароль">
        </v-text-field>
        <v-text-field
            :append-icon="showPasswordNew ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPasswordNew = !showPasswordNew"
            :type="showPasswordNew ? 'text' : 'password'"
            v-model="password"
            :rules="passRules"
            class="mb-4"
            outlined
            dense
            value=""
            placeholder="Новый пароль"
            @input="onValidateConfirmPass"
            persistent-hint
            single-line hint="Введите новый пароль">
        </v-text-field>
        <v-text-field
            :append-icon="showPasswordNewCon ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPasswordNewCon = !showPasswordNewCon"
            :type="showPasswordNewCon ? 'text' : 'password'"
            v-model="password_confirm"
            :rules="[v => this.password === this.password_confirm || 'Пароли не совпадают']"
            ref="confirm"
            class="mb-4"
            outlined
            dense
            value=""
            placeholder="Подтверждение нового пароля"
            persistent-hint
            single-line hint="Подтверждение нового пароля">
        </v-text-field>
        <div class="d-flex justify-center">
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="onSend"
            >
                Изменить пароль
            </v-btn>
        </div>
        <v-overlay :value="isFetching" :absolute="true">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
        </v-overlay>
    </v-form>
</template>

<script>
import * as apiUser from '@/api/user';
import { mapGetters, mapActions } from 'vuex';
import {validateErrToString} from '@/mixins/helper';
export default {
    name: 'ChangePassword',
    components:{
        
    },
    data () {
        return {
            showPassword: false,
            showPasswordNew: false,
            showPasswordNewCon: false,
            isFetching: false,
            formValid: true,
            passRules: [
                v => !!v || 'Поле обязательно для заполнения',
                v => /(?=.*[0-9])(?=.*[а-яa-z])(?=.*[А-ЯA-Z])/.test(v) || 'Требования к паролю: Буквы на кириллице или латинице, минимум одна прописная и одна заглавная, минимум одно число. Пароль должен содержать не менее 8 символов.',
                v => v.length >= 8 || 'Минимальная длина 8 символов',
            ],
            current_password: '',
            password: '',
            password_confirm: ''
        }
    },
      methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR']),
        onValidateConfirmPass(){
            this.$refs.confirm.validate()
        },
        async onSend(){
            if(!this.$refs.formReset.validate()){
                return;
            }
            this.isFetching = true;
            try{
                let response = await apiUser.changePassword(this.USER_ID, {
                    current_password: this.current_password, 
                    password: this.password,
                    password_confirmation: this.password_confirm,
                });
                this.SHOW_SUCCESS(response.data.message);
                this.clearForm();
            }catch(err){
              console.log(err);
              let message = 'Ошибка запроса на изменения пароля';
              if(undefined !== err.response.data.error){
                  message = err.response.data.error
              }else if(undefined !== err.response.data.errors && err.response.status == 422){
                  message = validateErrToString(err.response.data.errors);
              }
              this.SHOW_ERROR(message);
            }finally{
                this.isFetching = false;
            }
        },
        clearForm(){
            this.current_password = '';
            this.password = '';
            this.password_confirm = '';
            this.formValid = true;
        }
    },
    computed:{
        ...mapGetters('user', ['USER_ID'])
    },
}
</script>

<style src="./Edit.scss" lang="scss"></style>